import React, { useEffect, useState } from 'react';
import { getdata } from '../../util/global';
import { deliveryitem, deliveryitemdef, deliverypartneritem } from './Datatype';
import AdminDeliveryTable from './AdminDeliveryTable';
import AdminDeliveryForm from './AdminDeliveryForm';

export default function AdminDelivery() {
  const [deliverydata, setdeliverydata] = useState<any[]>([]);
  const [partners, setpartners] = useState<deliverypartneritem[]>([]);
  const [showmodal, setshowmodal] = useState("");
  const [formdata, setformdata] = useState<deliveryitem>(deliveryitemdef);

  const fetchdata = async () => {
    const deliveries = await getdata({ filter: { datatype: 'deliverydata' } });
    const subscriptions = await getdata({ filter: { datatype: 'subscriptiondata' } });
    const enricheddeliveries = (deliveries.reverse() || []).map((delivery: any) => {
    const sub = subscriptions?.find((s: any) => s._id === delivery._subscriptionid);
      return {
        ...delivery,
        address: sub?.address || '-',
        items: sub?.items || [],
        customername: sub?.name || '-'
      };
    });

    setdeliverydata(enricheddeliveries);

    const partnerdata = await getdata({ filter: { datatype: 'deliverypartnerdata', status: 'active' } });
    setpartners(partnerdata);
  };

  const openedit = (item: deliveryitem) => {
    setformdata({ ...deliveryitemdef, ...item });
    setshowmodal("showdeliveryform");
  };

  useEffect(() => {
    fetchdata();
  }, []);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h3 style={{ margin: 0 }}>Deliveries</h3>
        {/* <button className="btn btn-blue" onClick={openadd}>
          + Add Delivery
        </button> */}
      </div>

      <div className="card shadow-sm p-3">
        <AdminDeliveryTable deliverydata={deliverydata} openedit={openedit} />
      </div>

      <AdminDeliveryForm
        showmodal={showmodal}
        setshowmodal={setshowmodal}
        formdata={formdata}
        setformdata={setformdata}
        fetchdata={fetchdata}
        partners={partners}
      />
    </div>
  );
}
